import React from "react";
import { LoaderFunction } from "react-router";
import { Home } from "../home";
import { Project } from "../Project/Project";
import { ProjectData, Projects } from "./ProjectData";

export interface BaseNavData {
  name?: string;
  path?: string;
  index?: true;
  children?: NavData[];
  loader?: LoaderFunction;
  Component?: React.FC;
}

export interface PageData extends BaseNavData {
  name: string;
  path: string;
  children?: NavData[];
}

export interface PrefixRoute extends BaseNavData {
  children: NavData[];
  name?: undefined;
  path: string;
}

export interface IndexRoute extends BaseNavData {
  index: true;
  name?: undefined;
  path?: undefined;
  children?: undefined;
}

export type NavData = PageData | PrefixRoute | IndexRoute;

function ProjectDataLoader(project: ProjectData): LoaderFunction<{ project: ProjectData }> {
  return async () => {
    return { project: project };
  };
}

const ProjectRoutes: NavData[] = Projects.map((project) => ({
  path: project.name,
  name: project.name,
  loader: ProjectDataLoader(project),
  Component: Project,
}));

const BaseRoutes: NavData[] = [
  {
    path: "projects",
    name: "Projects",
    children: ProjectRoutes,
  },
];

export const WebsiteRoutes: NavData = {
  path: "/",
  name: "Home",
  children: [{ index: true, Component: Home }, ...BaseRoutes],
};
